import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import { loginRequest } from "./Auth/AuthConfig";

export const MGTProviderSetup: React.FC = () => {
  const { instance } = useMsal();

  useEffect(() => {
    if (!Providers.globalProvider?.provider) {
      Providers.globalProvider = new Msal2Provider({
        publicClientApplication: instance,
        scopes: loginRequest.scopes,
      });
    }
  }, [instance]);

  return null;
};
